import http from "../http-common";

class ConnectionDataService {

  getAll(id) {
    return http.get(`/connection/connections/${id}`);
  }

  getAllInterests(id) {
    return http.get(`/connection/connectioninterests/${id}`);
  }

  getOneByInterest(id, interestid) {
    return http.get(`/connection/${id}/${interestid}`);
  }

  get(id) {
    return http.get(`/connection/${id}`);
  }

  create(data) {
    return http.post("/connection", data);
  }

  update(id, interestid, data) {
    return http.put(`/connection/status/${id}/${interestid}`, data);
  }

  delete(id) {
    return http.delete(`/connection/${id}`);
  }

  deleteAll() {
    return http.delete(`/connection`);
  }

}

export default new ConnectionDataService();